module.exports = __webpack_public_path__ + "static/assets/781f9cb9ba110bb44ccb4fcbb35517c1.svg";